module.exports = __webpack_public_path__ + "img/eye-icon-new.9f2ffd21.svg";